module.exports = __webpack_public_path__ + "static/media/sixin_icon1.c3c61afb.png";